import { createAction, props } from '@ngrx/store';

// REST API / DB functions
export const fetchActivities = createAction('[activity] Fetch activities');

export const setActivities = createAction('[activity] Set activities', props<{ activities: any }>());
export const setCurrentAgentId = createAction('[activity] Set currentAgentId', props<{ id: string }>());
